var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { Callback as ActionModal } from '../modals/callback';
const portTranslator = (node) => [
    {
        connection: node.payload.next_node_id || uuid(),
        id: uuid(),
        label: 'arrow',
        type: 'out',
    },
];
export class CallbackNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        var _a;
        const { extraData, node } = this.props;
        const usedNumber = ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.from_number) || extraData.number;
        const phoneNumber = usedNumber
            ? numberFormatterInternational({ phoneNumber: usedNumber })
            : 'No number selected';
        return (_jsx(FlowNode, { color: CallbackNode.color, icon: CallbackNode.icon, label: CallbackNode.label, text: _jsxs("div", { children: [_jsx(AnnounceFromPayload, { node: node, extraData: extraData }), _jsxs("div", { children: ["Outbound number ", _jsx("strong", { children: phoneNumber })] })] }), onEdit: this.triggerEdit }));
    }
}
CallbackNode.icon = 'callback';
CallbackNode.label = 'Callback';
CallbackNode.color = flowNodeColor.orange;
CallbackNode.height = FlowNode.dimensions.h + 16;
CallbackNode.translatePayload = formatPortsHelper(portTranslator);
CallbackNode.ActionModal = ActionModal;
CallbackNode.actionTrigger = { type: FlowNodeTypes.CALLBACK };
CallbackNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.next_node_id = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], CallbackNode.prototype, "triggerEdit", null);
